import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const GraphList = ({ open, onClose, patientName, data, handleViewGraph }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        style: { borderRadius: 8, overflow: "hidden" },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          
          color: "grey.600",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
       {patientName}
        <IconButton onClick={onClose} sx={{ color: "grey.600" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Table Content */}
      <DialogContent sx={{ p: 3 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#0FB7A4" }}>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Sl No.
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Test Name
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Graph
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data && data.length > 0 ? (
              data.map((test, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:nth-of-type(odd)": { bgcolor: "#f5f5f5" },
                  }}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{test.TestName}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        bgcolor: "#0FB7A4",
                        textTransform: "none",
                        borderRadius: 2,
                        "&:hover": { bgcolor: "#0e9686ff" },
                      }}
                    //   onClick={() => window.open(test.graph_pdf_url, "_blank")}
                    onClick={() => handleViewGraph(test)}
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3}>
                  <Typography align="center">No tests available</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

export default GraphList;
